module.exports = __webpack_public_path__ + "static/media/LunellaApartmentINTBedroomA0076_bg_clean_v001.8c36a903.webp";